module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-inner-1c394a8dc8b812bc6e274abaa0ab6c4c.svg";